import React from 'react'
import ReactDOM from 'react-dom/client'
import { ThemeProvider } from '@mui/material/styles'
import CssBaseline from '@mui/material/CssBaseline'
import App from './App'
import theme from './theme'
import './index.css'

// Suppress React warnings for third-party libraries
const originalWarn = console.warn;
console.warn = (...args) => {
  // Suppress React Router v7 future flag warning
  if (args[0]?.includes?.('React Router will begin wrapping state updates')) {
    return;
  }
  // Suppress defaultProps warnings from third-party libraries
  if (args[0]?.includes?.('Support for defaultProps will be removed from function components')) {
    return;
  }
  originalWarn.apply(console, args);
};

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <App />
    </ThemeProvider>
  </React.StrictMode>
)